var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTick = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 21,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#19AD78",
  d: "M19.688 10.5c0 5.352-4.375 9.688-9.688 9.688A9.686 9.686 0 0 1 .313 10.5C.313 5.188 4.648.813 10 .813c5.313 0 9.688 4.375 9.688 9.687m-10.82 5.156 7.187-7.187a.66.66 0 0 0 0-.899l-.899-.86a.553.553 0 0 0-.86 0l-5.858 5.86-2.774-2.734a.553.553 0 0 0-.86 0l-.898.86a.66.66 0 0 0 0 .898l4.063 4.062a.66.66 0 0 0 .898 0"
})));
export default SvgTick;